import { Feature, useFeatureFlags } from '../../hooks/useFeatureFlags';
import { ReactNode } from 'react';

export function FeatureFlag({ type, children }: { type: Feature; children: ReactNode }) {
  const { data } = useFeatureFlags();

  return data?.[type] ? <>{children}</> : null;
}
